export default "__VITE_ASSET__$zfZi2lM__"